
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.806 13.637c.83 1.486 1.787 2.913 3.03 4.214 1.246 1.31 2.795 2.5 4.803 3.516.148.072.29.072.416.023.19-.073.385-.229.577-.42.149-.147.333-.382.527-.64.77-1.008 1.727-2.257 3.075-1.632.03.013.053.029.082.042l4.5 2.568c.013.007.03.023.043.03.594.404.838 1.03.845 1.736 0 .72-.268 1.53-.66 2.214-.518.903-1.282 1.5-2.163 1.897-.837.383-1.77.588-2.667.72-1.408.205-2.726.074-4.075-.338-1.32-.405-2.647-1.073-4.099-1.962l-.107-.068c-.665-.412-1.385-.854-2.09-1.375-2.585-1.935-5.216-4.728-6.93-7.803C.478 13.778-.307 10.992.122 8.336c.237-1.457.866-2.78 1.964-3.654.956-.765 2.245-1.184 3.913-1.037a.558.558 0 01.452.287L9.334 8.77c.422.543.474 1.08.244 1.617-.192.443-.577.848-1.104 1.228-.156.132-.34.265-.534.405-.646.465-1.378 1-1.127 1.632l-.007-.016zm5.374-2.31a.826.826 0 11.418-1.6c1.35.348 2.62 1.074 3.649 2.026 1.034.958 1.835 2.155 2.24 3.438a.828.828 0 01-.548 1.038.836.836 0 01-1.046-.544c-.317-1.005-.955-1.952-1.783-2.72-.835-.773-1.856-1.36-2.93-1.638zm.11-5.071a.83.83 0 01-.682-.956.835.835 0 01.963-.678c2.547.438 4.965 1.72 6.903 3.52 1.94 1.8 3.407 4.124 4.052 6.642a.837.837 0 01-1.62.408c-.568-2.213-1.86-4.259-3.569-5.844-1.704-1.583-3.823-2.71-6.046-3.092zm.538-4.604a.83.83 0 01-.735-.917.834.834 0 01.924-.73c3.563.414 6.911 2.036 9.561 4.42 2.657 2.388 4.62 5.55 5.403 9.034a.834.834 0 01-1.627.356c-.706-3.141-2.483-6-4.893-8.166-2.399-2.157-5.423-3.624-8.633-3.997z"}})])
          )
        }
      }
    